<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="站点名">
        <el-input placeholder="请输入名称" v-model="filter.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.assets_code" clearable></el-input>
      </el-form-item>
      <el-form-item label="设备名称">
        <el-input placeholder="请输入设备名称" v-model="filter.dev_name" clearable></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filter.ips_status" style="width: 120px" placeholder="选择状态" clearable class="filter-select">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间范围">
        <el-date-picker v-model="filter.dateRange" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button icon="el-icon-plus" type="success" @click="onAdd" v-permision_tjtf="'add'">新增切换IP计划</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="onBatchDelete" :disabled="!multipleSelection.length" v-permision_tjtf="'delete'">批量删除</el-button>
        <!-- 清空数据暂时隐藏不做 -->
        <!-- <el-button icon="el-icon-delete-solid" type="warning" @click="onClearAll" v-permision_tjtf="'delete'">清空数据</el-button> -->
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column label="序号" type="index" width="60" fixed="left"></el-table-column>
      <el-table-column label="站点名" prop="org_name" fixed="left" width="220" show-overflow-tooltip></el-table-column>
      <el-table-column label="资产码" prop="triplet_assetscode" width="120" show-overflow-tooltip fixed="left"></el-table-column>
      <el-table-column label="设备名" prop="ename" fixed="left" width="120" show-overflow-tooltip></el-table-column>
      <el-table-column label="设备服务" prop="interface_type_name" width="120px" fixed="left"></el-table-column>
      <el-table-column label="站点模式" prop="build_type_name" width="90"></el-table-column>

      <el-table-column label="参数" prop="eq_send_ip" width="80" show-overflow-tooltip></el-table-column>
      <el-table-column label="状态" width="110px">
        <template slot-scope="{ row }">
          <el-tag :type="getStatusInfo(row.ips_status).type" size="small">{{ getStatusInfo(row.ips_status).label }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="等待" prop="wait_time" width="100" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.ips_status === 0">{{ row.wait_time }}</span>
          <span v-else>{{ `--` }}</span>
        </template>
      </el-table-column>
      <el-table-column label="旧服最新时间" prop="old_last_time" width="150px" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.ips_status === 0">{{ row.old_last_time }}</span>
          <span v-else>{{ `--` }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark" width="100px" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.ips_status === 0">{{ row.is_gun_run ? "充电中，" : "" }}{{ row.is_set_ip ? "IP已发送" : "IP未发送" }}，{{ row.is_restart ? "重启指令已发，" : "重启指令未发，" }}{{ row.remark }}</span>
          <span v-else>{{ row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" width="150" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column label="修改时间" prop="modify_time" width="150px"></el-table-column> -->
      <el-table-column :label="$t('publics.operation')" width="120px" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onEdit(row)" v-permision_tjtf="'edit'">编辑</el-button>
          <el-button type="text" class="danger-text" @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 各状态设备数量统计 + 分页 同行展示 -->
    <div class="table-footer">
      <div class="status-statistics">
        <span v-for="(item, index) in statusOptions" :key="item.value" class="stat-item">
          <span class="stat-divider" v-if="index > 0"></span>
          <span class="stat-label">{{ item.label }}:</span>
          <span class="stat-value" :class="'stat-color-' + item.value">{{ statusCounts[item.value] || 0 }}</span>
        </span>
      </div>

      <div class="my-pagination">
        <el-pagination
          background
          layout="sizes,total,prev,pager,next,jumper"
          :total="pageParams.total"
          :page-size="pageParams.limit"
          :page-sizes="[5, 10, 50, 100, 500, 1000]"
          :current-page="pageParams.page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 新增时选择组织弹框 -->
    <select-org :show.sync="visible.selectOrg" @confirm="confirmSelectOrg"></select-org>

    <!-- 编辑切换计划弹框 -->
    <el-dialog title="编辑切换计划" :visible.sync="visible.edit" width="600px" custom-class="ips-edit-dialog">
      <el-form label-width="120px">
        <el-form-item label="站点名">
          <el-input :value="editRow.org_name" disabled></el-input>
        </el-form-item>
        <el-form-item label="资产码">
          <el-input :value="editRow.triplet_assetscode" disabled></el-input>
        </el-form-item>
        <el-form-item label="设备名">
          <el-input :value="editRow.ename" disabled></el-input>
        </el-form-item>
        <el-form-item label="设备服务">
          <el-input :value="editRow.interface_type_name" disabled></el-input>
        </el-form-item>
        <el-form-item label="站点模式">
          <el-input :value="editRow.build_type_name" disabled></el-input>
        </el-form-item>
        <el-form-item label="微服务通信参数">
          <el-input :value="editRow.eq_send_ip" disabled></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input :value="editRow.create_time" disabled></el-input>
        </el-form-item>

        <el-form-item label="修改时间">
          <el-input :value="editRow.modify_time" disabled></el-input>
        </el-form-item>

        <el-form-item label="设IP指令">
          <el-input :value="editRow.is_set_ip ? '已发送' : '未发送'" disabled></el-input>
        </el-form-item>
        <el-form-item label="重启指令">
          <el-input :value="editRow.is_restart ? '已发送' : '未发送'" disabled></el-input>
        </el-form-item>
        <el-form-item label="新状态">
          <el-select v-model="editForm.ips_status" placeholder="请选择新状态" class="full-width">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="3" v-model="editForm.remark" placeholder="请输入备注" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible.edit = false">取 消</el-button>
        <el-button type="primary" :loading="editLoading" @click="onSaveEdit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import selectOrg from "./components/select-org-ips.vue"
import { GetSiteIpSPageList, AddSiteIpSPlan_Pl, delSiteIpsPlan, batchDelSiteIpsPlan, clearSiteIpsPlan, updateIpsSite, getSiteIpSStatisticsApi } from "@/api/site_ips_plan"
import { mapGetters } from "vuex"

export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { selectOrg },
  data() {
    return {
      visible: {
        editGroup: false,
        costModel: false,
        selectOrg: false,
        edit: false
      },
      tableData: [],
      form: {
        name: "",
        address: "",
        remark: "",
        community_id: "",
        gps_lat: "",
        gps_lng: "",
        place_type: "",
        pic_json: []
      },
      seletType: {},
      billingModel: "powersite",
      modelParams: {},
      communityOptions: [],
      formRules: {},
      filter: {
        name: "",
        assets_code: "",
        dev_name: "",
        dateRange: [], // 使用一个数组来同时存储开始和结束时间
        ips_status: null
      },
      multipleSelection: [],
      statusCounts: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0 },
      statusOptions: [
        { value: 0, label: "待切换" },
        { value: 1, label: "切换成功" },
        { value: 2, label: "切换失败" },
        { value: 3, label: "无需切换" },
        { value: 4, label: "转人工" },
        { value: 5, label: "设备停用" },
        { value: 100, label: "站点数量" }
      ],
      editRow: {},
      editForm: {
        ips_status: 0,
        remark: ""
      },
      editLoading: false,
      loading: false,
      isUpdate: true,
      gid: ""
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.formRules = {
      name: [{ required: true, message: "请输入站点名", trigger: "blur" }],
      address: [{ required: true, message: "请输入地址", trigger: "blur" }],
      gps_lat: [{ required: true, message: "请输入纬度", trigger: "blur" }],
      gps_lng: [{ required: true, message: "请输入经度", trigger: "blur" }],
      place_type: [{ required: true, message: "请选择产地类型", trigger: "change" }],
      community_id: [{ required: true, message: "请选择所属社区", trigger: "change" }]
    }
    this.getData()
  },
  methods: {
    getModelId() {
      this.getData()
    },

    editChargingConfig(row) {
      this.seletType = row
      this.modelParams = { charging_config_id: row.charging_config_id, power_site_id: row.ID }
      this.visible.costModel = true
    },

    async onAdd() {
      this.visible.selectOrg = true
    },

    confirmSelectOrg(items) {
      this.visible.selectOrg = false
      AddSiteIpSPlan_Pl(items).then((res) => {
        this.$message.success(res.msg)
        this.toFilter()
      })
    },
    onDelete(row) {
      this.$confirm("确定要删除设备的切换计划吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        delSiteIpsPlan(row).then(() => {
          this.$message.success(`删除成功`)
          this.toFilter()
        })
      })
    },

    getStatusInfo(status) {
      const item = this.statusOptions.find((s) => s.value == status)
      const typeMap = { 0: "", 1: "success", 2: "danger", 3: "info", 4: "warning", 5: "warning", 100: "warning" }
      return { label: item ? item.label : "未知", type: typeMap[status] !== undefined ? typeMap[status] : "info" }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    onBatchDelete() {
      if (!this.multipleSelection.length) return
      this.$confirm(`确定要删除选中的 ${this.multipleSelection.length} 条切换计划吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const ids = this.multipleSelection.map((item) => item.ID)
        batchDelSiteIpsPlan(ids).then(() => {
          this.$message.success("批量删除成功")
          this.multipleSelection = []
          this.toFilter()
        })
      })
    },

    onClearAll() {
      this.$confirm("确定要清空当前搜索条件下的所有数据吗？此操作不可恢复！", "警告", {
        confirmButtonText: "确定清空",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        clearSiteIpsPlan({ ...this.filter }).then(() => {
          this.$message.success("清空成功")
          this.multipleSelection = []
          this.toFilter()
        })
      })
    },

    onEdit(row) {
      this.editRow = { ...row }
      this.editForm = {
        ips_status: Number(row.ips_status),
        remark: row.remark || ""
      }
      this.visible.edit = true
    },

    onSaveEdit() {
      this.editLoading = true
      updateIpsSite({
        ID: this.editRow.ID,
        ips_status: this.editForm.ips_status,
        remark: this.editForm.remark
      })
        .then(() => {
          this.$message.success("保存成功")
          this.visible.edit = false
          this.getData()
        })
        .finally(() => {
          this.editLoading = false
        })
    },
    getData_Params() {
      return {
        page: this.pageParams.page,
        start_time: this.filter.dateRange.length == 0 ? "" : this.filter.dateRange[0],
        end_time: this.filter.dateRange.length == 0 ? "" : this.filter.dateRange[1],
        pagesize: this.pageParams.limit,
        ...this.filter
      }
    },
    getData() {
      this.loading = true
      GetSiteIpSPageList(this.getData_Params())
        .then((res) => {
          const communityMap = {}
          this.communityOptions.forEach((community) => {
            communityMap[community.ID] = community.name
          })

          this.tableData = res.data.map((item) => {
            return {
              ...item,
              community_name: communityMap[item.community_id] || item.community_id
            }
          })
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
      if (this.pageParams.page === 1) {
        this.getSiteIpSStatistics()
      }
    },
    getSiteIpSStatistics() {
      getSiteIpSStatisticsApi(this.getData_Params())
        .then((res) => {
          const list = (res && (res.outputData || res.data)) || []
          const counts = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 100: 0 }
          list.forEach((item) => {
            if (counts[item.ips_status] !== undefined) {
              counts[item.ips_status] = item.count
            }
          })
          this.statusCounts = counts
        })
        .finally(() => {})
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}

.filter-select {
  width: 150px;
}

.full-width {
  width: 100%;
}

.danger-text {
  color: #f56c6c;
}

.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.status-statistics {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  width: fit-content;
  max-width: 100%;
  padding: 10px 16px;
  margin: 12px 0;
  background: #f5f7fa;
  border-radius: 6px;
  font-size: 14px;
}

.stat-item {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.stat-divider {
  display: inline-block;
  width: 1px;
  height: 14px;
  background: #dcdfe6;
  margin: 0 16px;
}

.stat-label {
  color: #606266;
}

.stat-value {
  margin-left: 6px;
  font-weight: 600;
  color: #409eff;
}

.stat-value.stat-color-1 {
  color: #67c23a;
}

.stat-value.stat-color-2 {
  color: #f56c6c;
}

.stat-value.stat-color-3 {
  color: #909399;
}

.stat-value.stat-color-4 {
  color: #e6a23c;
}

@media screen and (max-width: 768px) {
  .status-statistics {
    padding: 8px 12px;
    font-size: 13px;
  }

  .stat-divider {
    margin: 0 10px;
  }

  .table-footer {
    flex-direction: column;
    align-items: flex-start;
  }
}

.table-footer .my-pagination {
  position: relative;
  z-index: 2;
  margin: 12px 0;
  background: #fff;
}

.app-container ::v-deep .table-footer .my-pagination .el-pagination {
  background: transparent;
}

.app-container ::v-deep .el-table {
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.app-container ::v-deep .el-button {
  border-radius: 6px;
  transition: all 0.25s ease;
}

.app-container ::v-deep .el-button:active {
  transform: scale(0.96);
}

.app-container ::v-deep .el-input__inner {
  border-radius: 6px;
}

::v-deep .ips-edit-dialog {
  border-radius: 10px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

::v-deep .ips-edit-dialog .el-dialog__body {
  padding-top: 10px;
}

@media screen and (max-width: 768px) {
  .filter-select {
    width: 120px;
  }

  ::v-deep .ips-edit-dialog {
    width: 92% !important;
  }
}
</style>
